import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import AddAlertIcon from '@material-ui/icons/AddAlert';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';//deferidas
import PinDropIcon from '@material-ui/icons/PinDrop';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import Dialog from '@material-ui/core/Dialog';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormLabel from '@material-ui/core/FormLabel';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import { deepOrange, green } from '@material-ui/core/colors';
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing';
import Tooltip from '@material-ui/core/Tooltip';
import Cardtransferir from './cardtransferir';
import Grid from '@material-ui/core/Grid';
import Cardselectmotora from './cardselectmotoraecia';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import { dateTimePickerDefaultProps } from '@material-ui/pickers/constants/prop-types';
import { DateTimePicker } from '@material-ui/pickers';
import Cardmap from './apmap';
import Cardmaproute from './aproute';
import { ControlPointDuplicateOutlined } from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import Localiza from './Localiza';
import {useHistory } from 'react-router-dom';
import Mapdialog from './mapdialog';
import ExploreIcon from '@material-ui/icons/Explore';
import { Impressaoviagem } from '../util/Impressaoviagem';
import { Impressaointerno } from '../util/Impressaointerno';
import { Impressaootdeferido } from '../util/Impressaootdeferido';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AssignmentIcon from '@material-ui/icons/Assignment';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    alignContent:'LEFT',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  datas:{
    alignItems: 'center',
    marginTop: theme.spacing(2),

  },
  rounded: {
    color: green[500],
    //backgroundColor: green[500],
  },
  rounded2: {
    color: red[500],
    //backgroundColor: green[500],
  },
  rounded3: {
    color: green[500],
    //backgroundColor: green[500],
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

var listalocal=[];
     
 export default function RecipeReviewCard(props) {

  //***************************** */
  var marcacao = [];
  const visualizarsolicitacao = () => {
    console.log(props);
  //var rel = Impressaosolicitacao(props)
    //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
    //rel.criarpdf();
    if(props.props[0].tipodeslocamento==2){
      const classeImpressaov = new Impressaoviagem(props);
      const documentov = classeImpressaov.GerarDocumento();
      pdfMake.createPdf(documentov).open({}, window.open('', '_blank'));
    }else{
      if(props.props[0].tipodeslocamento==1){
        const classeImpressao = new Impressaointerno(props);
        const documento = classeImpressao.GerarDocumento();
        pdfMake.createPdf(documento).open({}, window.open('', '_blank'));
      }
    }
    
  }

  //****************************visualiza ordem */
const visualizarordem = () => {
  console.log(props);
//var rel = Impressaosolicitacao(props)
  //pdfMake.createPdf(Impressaosolicitacao).open({}, window.open('', '_blank'));
  //rel.criarpdf();
  
    const classeImpressaoot = new Impressaootdeferido(props,marcacao);
    const documentoot = classeImpressaoot.GerarDocumento();
    pdfMake.createPdf(documentoot).open({}, window.open('', '_blank'));
  
  
  
}

//************************************** */

  let history = useHistory();
  

  const[stid, setaid]=React.useState('');
  const[datahoraretorno, setadatahoraretorno]=React.useState('');
  const[dataretornoreal, setadataretornoreal]=React.useState();
  const[datahorasaida, setadatahorasaida]=React.useState('');
  const[datahorasaidareal, setadatahorasaidareal]=React.useState('');
  const[depsolicitente, setadepsolicitante]=React.useState('');
  const[dsolicitacao, setadsolicitacao]=React.useState('');
  const[nomesolicitante, setanomesolicitante]=React.useState('');
  const[lotacaosolicitante, setalotacaosolicitante]=React.useState('');
  const[telefonesolicitante, setatelefonesolicitante]=React.useState('');
  const[objetivo, setaobjetivo]=React.useState('');
  const[nsolicitacao, setansolicitacao]=React.useState('');
  const[npassageiro, setanpassageiro]=React.useState('');
  const[siapesolicitente, setasiapesolicitente]=React.useState('');
  const[listaparadasvolta, setalistaparadasvolta]=React.useState(['']);
  const[listaparadasida, setalistaparadasida]=React.useState(['']);
  const[listapassageiros, setalistapassageiros]=React.useState(['']);
  const[localdestino, setalocaldestino]=React.useState('');
    const[localsaida, setalocalsaida]=React.useState('');
    const[localdestinomapa, setalocaldestinomapa]=React.useState(['']);
  const[localsaidamapa, setalocalsaidamapa]=React.useState(['']);
  const[geolocalsaidamapa, setageolocalsaidamapa]=React.useState(['']);
  const[temporetorno, setatretorno]=React.useState('');
  const[geolocaldestinomapa, setageolocaldestinomapa]=React.useState(['']);
  const[campisolicitante, setacampisolicitante]=React.useState('');
  const[observacao, setaobservacao]=React.useState('');
  //const[anexos, setaanexos]=React.useState('');
  const[autorizacoes, setaautorizacoes]=React.useState([]);
  const[tipodeslocamento, setatipodeslocamento]=React.useState('');
  const[tipodesl, setatipodesl]=React.useState(0);
  const[nomerespdespesas, setanomerespdespesas]=React.useState('');
  const[fonerespdespesas, setafonerespdespesas]=React.useState('');
  const[stdivdespesas, setastdivdespesas]=React.useState(true);
  const[stdivcontroles, setastdivcontroles]=React.useState(true);
  const[stbttransferir, setastbttransferir]=React.useState(true);
  const[stbtdeferirmento, setastbtdeferirmento]=React.useState(false);
  const[stbtindeferirmento, setastbtindeferirmento]=React.useState(true);
  const[unidadetransferencia, setaunidadetransferencia]=React.useState('');
  const[kilometragem, setakilometragem]=React.useState('');
  const[passageiros, setapassageiros]=React.useState('');
  const[anexo, setaanexo]=React.useState([]);
  const[rdespesas, setardespesas]=React.useState(1);
  const[stocorrencia, setaocorrencia]=React.useState([]);
  const[ststatususer, setaststatususer]=React.useState();
  const[userfinaliza, setauserfinaliza]=React.useState(true);
  const[idsolicitante, setaidsolicitante]=React.useState('');
  const[valorkmrodado, setavalorkmrodado]=React.useState('');
  const[motorista, setamotorista]=React.useState('');
const[veiculo, setaveiculo]=React.useState('');
const[vermotorista, setavermotorista]=React.useState('');
const[verveiculo, setaverveiculo]=React.useState('');
const[km, setakm]=React.useState('');
const[sttemporetorno, setatemporetorno]=React.useState('');


  
 
//********************objeto veiculo******************* */

const [itemagenda, setitemagenda] = React.useState([]);

var tipodesloc;
var respdesp;
var pagina;
React.useEffect(()=>{
  setitemagenda(props.props);
  console.log("item agend props ", props.props)
},[props])

React.useEffect(() => {
  console.log("item agend props ", props.usertipo)
  
var dt='';
var datar='' ;
itemagenda.forEach(modelo=>(dt=modelo.datahoraretorno));
console.log("Documentuswss data updated!", dt);
if (dt!=undefined) {
  setadataretornoreal(dt);
  datar= new Date(dt.seconds*1000).toLocaleString("pt-BR");
  console.log("Documentuswss data updated!", datar);
  console.log("Document data updated!", datar);
}
//
var id='';
itemagenda.forEach(modelo=>(id=modelo.id));
setaid(id);

setadatahoraretorno(datar);
var dts='';
var datas=''
itemagenda.forEach(modelo=>(dts=modelo.datahorasaida));
if (dts!=undefined) {
  setadatahorasaidareal(dts);
  datas= new Date(dts.seconds*1000).toLocaleString("pt-BR");
  
}
setadatahorasaida(datas);
var depsol;
itemagenda.forEach(modelo=>(depsol=modelo.depsolicitacao));
console.log('valor do stateauco ',depsol);
if(depsol!=undefined){
  console.log('valor do stateauco ',depsol[0].nomedepsol);
setadepsolicitante(depsol[0].nomedepsol);
}

itemagenda.forEach(modelo=>(tipodesloc=modelo.tipodeslocamento));
console.log('valor do stateauco ',tipodesloc);
setatipodesl(tipodesloc)
if(tipodesloc==1){
  setatipodeslocamento('Deslocamento Interno')
}else{
  if(tipodesloc==2){
    setatipodeslocamento('Viagem')
   
itemagenda.forEach(modelo=>(respdesp=modelo.respdespesas));
console.log('responsavel' ,respdesp);
if((respdesp!='')||(respdesp!=undefined)){
  setardespesas(respdesp)
}
    var nomerespdesp;
itemagenda.forEach(modelo=>(nomerespdesp=modelo.nomerespdespesas));
setanomerespdespesas(nomerespdesp);
var fonerespdep;
itemagenda.forEach(modelo=>(fonerespdep=modelo.fonerespdespesas));
setafonerespdespesas(fonerespdep);
setastdivdespesas(false);
  }
}

var vkm ='';
itemagenda.forEach(modelo=>(vkm=modelo.valorkmrodado))
//alert (vkm);
setavalorkmrodado(vkm);

var km ='';
itemagenda.forEach(modelo=>(km=modelo.totalkm))
setakilometragem(km);

var ps ='';
var pss='';
itemagenda.forEach(modelo=>(ps=modelo.listapassageiros))
for (let index = 0; index < ps.length; index++) {
  pss = pss  + ps[index].passageiro.nome + ', ';
  console.log("psssss " + ps[index])
  console.log("psssss " , pss)
}
setapassageiros(pss);



var dsol ='';
itemagenda.forEach(modelo=>(dsol=modelo.dsolicitacao))
setadsolicitacao(dsol);
var nomesol=';'
itemagenda.forEach(modelo=>(nomesol=modelo.nomesolicitante))
setanomesolicitante(nomesol);
var cp ='';
itemagenda.forEach(modelo=>(cp=modelo.campisolicitante))
setacampisolicitante(cp);
var telsol = '';
itemagenda.forEach(modelo=>(telsol=modelo.telefonesolicitante))
setatelefonesolicitante(telsol);
var obj = '';
itemagenda.forEach(modelo=>(obj=modelo.objetivo))
setaobjetivo(obj);
var nsol = '';
itemagenda.forEach(modelo=>(nsol=modelo.nsolicitacao))
//setlot(lota);
setansolicitacao(nsol);
var np='';
itemagenda.forEach(modelo=>(np=modelo.npassageiro))
setanpassageiro(np);
var siapesol='';
itemagenda.forEach(modelo=>(siapesol=modelo.siapesolicitente))
setasiapesolicitente(siapesol);
var obs = '';
itemagenda.forEach(modelo=>(obs=modelo.observacao))
setaobservacao(obs);


var idsol = '';
itemagenda.forEach(modelo=>(idsol=modelo.idsolicitante))
setaidsolicitante(idsol);

var aut = '';

itemagenda.forEach(modelo=>(aut=modelo.autorizacoes));
console.log("autorizacoes ",aut)
if((aut!=undefined)&&(aut!='')){
  setaautorizacoes(aut);
}
var statusu;
itemagenda.forEach(modelo=>(statusu=modelo.statususer));
console.log("autorizacoes ",aut)
if(statusu==false){
  setaststatususer(false);
  
}else{
  if(statusu==undefined){
    setaststatususer(true);
  }
}


/*
itemagenda.forEach(modelo=>(listaparadas=modelo.listaparadas))
//setlot(lota);
itemagenda.forEach(modelo=>(listapassageiros=modelo.listapassageiros))
//setlot(lota);
*/
var dest='';
itemagenda.forEach(modelo=>(dest=modelo.localdestino))
setalocaldestinomapa(dest);
setalocaldestino(dest.description);
console.log('destino', localdestino )
var saida='';
itemagenda.forEach(modelo=>(saida=modelo.localsaida));
setalocalsaidamapa(saida);
setalocalsaida(saida.description);

var pida='';
itemagenda.forEach(modelo=>(pida=modelo.listaparadasida));
if((pida!='')&&(pida!=null)&&(pida!=undefined)){
  setalistaparadasida(pida);
}
//setalistaparadasida(pida);
var volta='';
itemagenda.forEach(modelo=>(volta=modelo.listaparadasvolta));
setalistaparadasvolta(volta);

var ane='';
itemagenda.forEach(modelo=>(ane=modelo.anexo));
if((ane!='')&&(ane!=undefined)){
  console.log("arquivo ", ane)
  const storageRef = firebase.storage().ref();
  const storageRefChild = storageRef.child('anexosagenda/' + id + '/' + ane);
  console.log("arquivo ", storageRefChild.name);
  //console.log("arquivo ", input)

  storageRefChild.getDownloadURL().then(function (url) { 
    // O url de serviço pode ser inserido em um <img> 
    //var img = document.getElementById ('muimui'); 
    console.log("arquivo ", url)
    //var img = url;
    setaanexo([{nome: ane, link: url}])
   // var link_item = document.getElementById('download-link')
   // link_item.setAttribute('href', url)
   // alert('uri anexo', img); 

  }) 
  .catch (function (err) { 
    console.log('Anexado'); 
  })


}


 
  var m='';
  itemagenda.forEach(modelo=>(m=modelo.motorista));
  setamotorista(m);
  if((m!='')&&(m!=undefined)){
    setavermotorista(m.label);
  }
  var v='';
  itemagenda.forEach(modelo=>(v=modelo.veiculo));
  setaveiculo(v);
  if((v!='')&&(v!=undefined)){
    setaverveiculo(v.label);
  }

},[itemagenda]);

//**********************************pegar anexos */



//*********************///*/









var listaassina 


const handleassina=()=>{

  console.log("Document autorizacao aqui!", autorizacoes);
  var unit = firebase.firestore().collection("agenda").doc(stid);
  return unit.update({autorizacoes: listaassina})
.then(() => {
  console.log("Document autorizacao updated!");
})
.catch((error) => {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
});
}

const handleuserconclui =()=>{

  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'Encerrou a Solicitação'

  }
  
  
 
  listaassina = autorizacoes;
  listaassina.push(assina);
  setaautorizacoes(currentArray => [...currentArray, assina]);
  console.log("Document autorizacao updated!", listaassina);
     var unit = firebase.firestore().collection("agenda").doc(stid);
      return unit.update({statususer:true, status:'concluido'})
    .then(() => {
      console.log("Document successfully updated!");
      setauserfinaliza(true);
      handleassina();
      alert("Solicitação Concluida");
      window.open('https://forms.gle/AgT6AWNjA2yyZafm7', '_blank');
      history.push("/PageInit");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    
  

             //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  
  const handleExpandClick = () => {
    setExpanded(!expanded);
    if(expanded){
    
  }};

  //**************************** *
 const [openocorrencia, setaopenocorrencia] = React.useState(false);

 const handleClickopenocorrencia = () => {
   var db3 = firebase.firestore();
  var query =  db3.collection("agenda").doc(props.props[0].id).collection("ocorrencias").get()
  .then(function(querySnapshot) {
    setaocorrencia([])
    querySnapshot.forEach(function(doc) {
      var listaocorrencias=[];
       
      listaocorrencias.push({nomeassina:doc.data().nomeassina, ocorrencia: doc.data().ocorrencia, datahora:doc.data().datahora})
                
      console.log(listaocorrencias)
      setaocorrencia (currentArray => [...currentArray, listaocorrencias]);
  
})
setaopenocorrencia(true);

})





.catch(error => {
   console.log(error);
});

   
 };

 const handleClosedopenocorrencia = () => {
   setaopenocorrencia(false);
 };


    //*********************************** */
    const[stmarcacao, setamarcacao]=React.useState([]);
    const [openmarcacao, setaopenmarcacao] = React.useState(false);
    
    
    
    const handleClickopenmarcacao = () => {
    
      var db3 = firebase.firestore();
      var query =  db3.collection("agenda").doc(props.props[0].id).collection("marcacoes").orderBy('datahora').get()
      .then(function(querySnapshot) {
       setamarcacao([])
        querySnapshot.forEach(function(doc) {
          var listaocorrencias=[];
           
          listaocorrencias.push({marcacao: doc.data().marcacao, datahora:doc.data().datahora})
                    
          console.log(listaocorrencias)
          setamarcacao (currentArray => [...currentArray, listaocorrencias]);
      
      })
      setaopenmarcacao(true);
      
      }).catch(error => {
       console.log(error);
      });
      
    
     
    };
    
    const handleClosedopenmarcacao = () => {
     setaopenmarcacao(false);
    };
    

    //********************************** */
    const [openitinerariomapa, setaopenitinerariomapa] = React.useState(false);
 
 const handleClickopenitinerariomapa
  = () => {
  setaopenitinerariomapa(true);
 };

 const handleCloseditinerariomapa = () => {
  setaopenitinerariomapa(false);
 };


 //************************************ */
 /******************************** */
const[stregocorrencia, setastregocorrencia]=React.useState('')
const handleocorrencia =()=>{
  
    
  var assina ={
    idassina:props.user,
    nomeassina:props.usernome,
    siapeassina:props.usersiape,
    acao:'atualizaçao'

  }
/*
  var db=firebase.firestore();
  var washingtonRef = db.collection("agenda").doc("stid");

  washingtonRef.update({
    autorizacoes: firebase.firestore.FieldValue.arrayUnion(assina)
});

  
  
  setaautorizacoes(currentArray => [...currentArray, assina]);
  listaassina = autorizacoes;
  listaassina.push(assina);*/
  console.log("Document autorizacao updated!", listaassina);
    
      
        var unit = firebase.firestore().collection("agenda").doc(stid).collection('ocorrencias').doc();

        
      unit.set({nomeassina:props.usernome,ocorrencia:stregocorrencia,datahora:firebase.firestore.Timestamp.fromDate(new Date())})
    .then(() => {
      console.log("Document successfully updated!");
      
     // handleassina();
      handleClosedopenregocorrencia();
      alert("Ocorrência Registrada");
    })
    .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });

    }

    

    //************************************************ */
  //************************************************ */

  const [openregocorrencia, setaopenregocorrencia] = React.useState(false);

  const handleClickopenregocorrencia = () => {
    setaopenregocorrencia(true);
  };

  const handleClosedopenregocorrencia = () => {
    setaopenregocorrencia(false);
  };

//******************************** */

  return (
    <Card className={classes.root} >
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title= {nsolicitacao}
             subheader= {dsolicitacao}
     
           />
           <CardContent>
           

           <Dialog open={openmarcacao} variant="outlined" onClose={handleClosedopenmarcacao} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Marcações</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          {stmarcacao.map(item=>(
           console.log(item[0]),
           <Typography variant="body2" color="textSecondary" component="p">
           Marcação: {item[0].marcacao}
          <br></br>
        Data: {new Date(item[0].datahora.seconds*1000).toLocaleString("pt-BR")}
        <br></br>
        <br></br>
       </Typography>
       
         ))}     
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
                      
          <Button variant="contained" onClick={handleClosedopenmarcacao} color="primary" >
            Ok
          </Button>
          </DialogActions>
      </Dialog>
           
                <Typography variant="body2" color="textSecondary" component="p">
               {campisolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {depsolicitente}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Nome Solicitante: {nomesolicitante}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               {tipodeslocamento}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Objetivo: {objetivo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Quilometragem: {kilometragem}
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Veículo: {verveiculo}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Motorista: {vermotorista}
             </Typography>
             
                         
             <TextField
            className={classes.datas}
         id="datetimeini2"
        label="Data e hora da Saída"
        disabled={true}
        value={datahorasaida}
        />
         <TextField
             className={classes.datas}
             id="datetimeini"
            label="Data e hora do Retorno"
            disabled={true}
            
            value={datahoraretorno}
            />



             

            <Dialog open={openocorrencia} variant="outlined" onClose={handleClosedopenocorrencia} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Ocorrências</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
         {stocorrencia.map(item=>(
           console.log(item[0]),
           <Typography variant="body2" color="textSecondary" component="p">
           Nome: {item[0].nomeassina}
         <br></br>
         Ocorrência: {item[0].ocorrencia}
         <br></br>
        Data: {new Date(item[0].datahora.seconds*1000).toLocaleString("pt-BR")}
        <br></br>
        <br></br>
       </Typography>
       
         ))}     
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
                      
          <Button variant="contained" onClick={handleClosedopenocorrencia} color="primary" >
            Ok
          </Button>
          </DialogActions>
      </Dialog>

      <Dialog open={openregocorrencia} variant="outlined" onClose={handleClosedopenregocorrencia} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Registrar Ocorrência</DialogTitle>
        <DialogContent>
          <DialogContentText>
         
          <TextField
          variant="outlined" 
          margin="normal" aria-label="minimum height"
        
          onChange={ e=>setastregocorrencia(e.target.value)}
          type="Float"
          fullWidth
          id="valortotal"
          label="Ocorrência"
          name="observacao"  
             multiline
             rows={5}
        
          />

         
                 

         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
            <Button variant="contained" onClick={handleocorrencia} color="primary" >
            Salvar
          </Button>
           
          <Button variant="contained" onClick={handleClosedopenregocorrencia} color="primary" >
            Cancelar
          </Button>
          </DialogActions>
      </Dialog>


      

      <Dialog  open={openitinerariomapa} variant="outlined" onClose={handleCloseditinerariomapa} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-naodep">Itinerário</DialogTitle>
        <DialogContent>
          <DialogContentText>
        
         <Mapdialog   props={stid}/>
          
         </DialogContentText>
            
        </DialogContent>
        <DialogActions>
            
           
          <Button variant="contained" onClick={handleCloseditinerariomapa} color="primary" >
            OK
          </Button>
          </DialogActions>
      </Dialog>


             
             

           </CardContent>

          
            <CardActions disableSpacing>
                <div >

                
                

    
    <Tooltip title={"Itinerário"}>
              <IconButton
         className={classes.rounded3}
         onClick={handleClickopenitinerariomapa}
         //disabled={stbtsalvarveiculo}
         //aria-expanded={expanded}
         aria-label="Visualizar documento"
        
       >
         <ExploreIcon />
         
        
       </IconButton>
       </Tooltip>
       <Tooltip title={"Ordem de Trânsito"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarordem}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <ListAltIcon />
     
    </IconButton>
    </Tooltip>
    <Tooltip title={"Solicitação de Transporte"}>
           <IconButton
      className={classes.rounded3}
      onClick={visualizarsolicitacao}
      //disabled={stbtsalvarveiculo}
      //aria-expanded={expanded}
      aria-label="Visualizar documento"
     
    >
      <AssignmentIcon />
     
    </IconButton>
    </Tooltip>
           
    <Tooltip title={"Marcações"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopenmarcacao}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <AccessTimeIcon />
    </IconButton>
    </Tooltip>

    <Tooltip title={"Ocorrências"}>
           <IconButton
      //disabled={stbtdeferi}
     // className={classes.rounded}
      onClick={handleClickopenocorrencia}
      aria-expanded={expanded}
      aria-label="checklist"
      
    >
      <ReportProblemIcon />
    </IconButton>
    </Tooltip>
     
             </div>
             <br></br>
             <br></br>
             
             <div>
             <Button
       variant="contained"
       color="secondary"
       
       onClick={handleClickopenregocorrencia}//{handleClickopenocorrencia}
       className={classes.menuButton}
       >
       Registrar Ocorrência
       </Button>
       <br></br>
             <br></br>
             

             <Button  disabled={ststatususer} variant="contained" onClick={handleuserconclui} color="primary" >
            Concluir Deslocamento
          </Button>
          </div>

             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
           </CardActions>
           <Collapse in={expanded} timeout="auto" unmountOnExit>
             <CardContent>
             <Typography variant="body2" color="textSecondary" component="p">
              Saída: {localsaida}
               
               
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Destino: {localdestino}
               
               
             </Typography>

              <div hidden={stdivdespesas}>
                

               <Typography variant="body2" color="textSecondary" component="p">
               Responsável pelas Despesas: {nomerespdespesas}
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Telefone Responsável pelas Despesas: {fonerespdespesas}
             </Typography>
               </div>

              

             <Typography variant="body2" color="textSecondary" component="p">
               Nº Passageiros: {npassageiro}
               <br></br>
               {passageiros}
               
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Observações: {observacao}
             </Typography>
             
              { anexo.map(item=>(
                <Typography variant="body2" color="textSecondary" component="p">
                  Anexo:
                  <br></br>
                <Link  href={item.link} target="_blank" rel="noopener">{item.nome}</Link>
                </Typography>
              ))

              }
               
             <Typography variant="body2" color="textSecondary" component="p">
               Autorizações: 

               </Typography>
                 
                 
               {autorizacoes.map(item=>(
                 console.log(item),
                <Typography variant="body2" color="textSecondary" component="p">
                Nome: {item.nomeassina}
                <br></br>
                Siape: {item.siapeassina}
                <br></br>
                {item.acao}
                <br></br>
              </Typography>
                 
              ))}
             
            
              
     
             </CardContent>
             <CardActions disableSpacing>
           
                
             <IconButton
               className={clsx(classes.expand, {
                 [classes.expandOpen]: expanded,
               })}
               onClick={handleExpandClick}
               aria-expanded={expanded}
               aria-label="Visualizar"
             >
               <ExpandMoreIcon />
             </IconButton>
     
             
     
           </CardActions>
           </Collapse>
         </Card>
  );
}